import { Player } from "../app/player";

let computer = new Player("computer");
let player = new Player("player");
let inValidChoices = new Map();

export { player, computer, inValidChoices };
